import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafePipe } from '../../../pipes/safe-string/safe.pipe';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'upsc-site-announcement-dialog',
  templateUrl: './site-announcement-dialog.component.html',
  styleUrls: ['./site-announcement-dialog.component.scss'],
})
export class SiteAnnouncementDialogComponent implements OnInit {
  public message: string | SafeHtml;

  constructor(private safePipe: SafePipe,
              public dialogRef: MatDialogRef<SiteAnnouncementDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = this.safePipe.transform(data.message, 'html');
  }

  public ngOnInit() {
  }
}
